const TOAST_ERROR_TYPE = 'error';
let timeout = null;

function showToast(message, type, container) {
  container = container || '.toast-container';
  let $toast = $(container + ' .toast');
  if (!$toast.length) {
    $(container).append('<div class="toast"></div>');
    $toast = $(container + ' .toast');
  }
  if (timeout) {
    clearTimeout(timeout);
    $toast.removeClass('error');
    $toast.removeClass('success');
    timeout = null;
  }
  if (type === TOAST_ERROR_TYPE) {
    $toast.text(message).addClass('active').addClass('error');
    timeout = setTimeout(function () {
      $toast.removeClass('active');
      $toast.removeClass('error');
      $toast.text('');
      timeout = null;
    }, 7000);
  } else {
    // SUCCESS TYPE
    $toast.text(message).addClass('active').addClass('success');
    timeout = setTimeout(function () {
      $toast.removeClass('active');
      $toast.removeClass('success');
      $toast.text('');
      timeout = null;
    }, 7000);
  }
}

// -------------------- MULTISELECT JS START --------------------
var style = document.createElement('style');
style.setAttribute('id', 'multiselect_dropdown_styles');
style.innerHTML = `
.multiselect-dropdown{
  display: inline-block;
  border: 1px solid #286fa8;
  border-radius: 0.5rem;
  outline: none;
  width: 100%;
  position: relative;
  background: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAQAAAC1QeVaAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAHdElNRQflCgUMCjLMEYhsAAAAn0lEQVQY07XPMWoCUQCE4W92G9MkRSBVKi8gIp5k8SARNoVHSIo9SLJXEhSrQJDYRGxeil3JCZxy/mGG4SbKJ/flrnylrEbrQ0me8utUSZllUy8vetC7qJfZlJlUKdmrrScLej0mC2t19ikV5106R625iLnWMd15Rwx1U68evKP1482WRoadET/jcEUGOAamXtDZNtcr/696HvHduLH+AG1GLEg6gjKDAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTEwLTA1VDEyOjEwOjUwKzAwOjAwcLdh+wAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0xMC0wNVQxMjoxMDo1MCswMDowMAHq2UcAAAAASUVORK5CYII=");
  background-repeat: no-repeat;
  background-position: right 2% bottom 50%;
  padding: 18px;
}
.multiselect-dropdown span.optext{
  margin-right:0.5em;
  margin-bottom:2px;
  padding:1px 0;
  border-radius: 4px;
  display:inline-block;
  font-family: Montserrat,sans-serif;
  font-size: .9rem;
  color: #3f3f3f;
}
.multiselect-dropdown span.placeholder{
  color: hsla(0,0%,58%,1);
  font-family: Montserrat,sans-serif;
  font-size: 100%;
}
.multiselect-dropdown span.optext{
  padding:0.1em 0.75em;
  border: 1px solid #ececec;
}
.multiselect-dropdown span.optext img{
  margin-right: .2rem;
}
.multiselect-dropdown span.optext .optdel {
  float: right;
  margin: 0 -6px 1px 5px;
  font-size: 0.8em;
  margin-top: 2px;
  cursor: pointer;
  color: #666;
}
.multiselect-dropdown span.optext .optdel:hover {
  color: #c66;
}
.multiselect-dropdown-list-wrapper{
  z-index: 100;
  border-radius: 0.5rem;
  border: solid 1px #ececec;
  display: none;
  margin: -2px;
  position: absolute;
  top:0;
  left: 0;
  right: 0;
  background: white;
}
.multiselect-dropdown-list-wrapper .multiselect-dropdown-search{
  margin-bottom:2px;
}
.multiselect-dropdown-list{
  padding:2px;
  height: 11.5rem;
  overflow-y:auto;
  overflow-x: hidden;
  background-color: #f3f3f3;
}
.multiselect-dropdown-list::-webkit-scrollbar {
  width: 6px;
}
.multiselect-dropdown-list::-webkit-scrollbar-thumb {
  background-color: #bec4ca;
  border-radius:3px;
}

.multiselect-dropdown-list div{
  padding: 5px;
  display: flex;
  align-items: center
}
.multiselect-dropdown-list div label{
  font-weight: 400 !important;
}
.multiselect-dropdown-list div label img{
  margin-right: 0.2rem;
}
.multiselect-dropdown-list div input[type=checkbox]+label:before {
  top: 4px;
  margin-right: .5rem;
}
.multiselect-dropdown-list input{
  height: 1.15em;
  width: 1.15em;
  margin-right: 0.35em;
}
.multiselect-dropdown-list div.checked{
}
.multiselect-dropdown-list div:hover{
  cursor: pointer;
}
.multiselect-dropdown span.maxselected {width: auto;}
.multiselect-dropdown-all-selector {border-bottom:solid 1px #999;}


@media (max-width: 520px) {
  .multiselect-dropdown-list {
    height: 13.5rem !important;
  }
}

`;
document.head.appendChild(style);

function MultiselectDropdown(options) {
  var config = {
    search: true,
    height: '11rem',
    placeholder: 'Select Verticals',
    txtSelected: 'selected',
    txtAll: 'All',
    txtRemove: 'Remove',
    txtSearch: 'Search',
    ...options,
  };
  function newEl(tag, attrs) {
    var e = document.createElement(tag);
    if (attrs !== undefined)
      Object.keys(attrs).forEach((k) => {
        if (k === 'class') {
          Array.isArray(attrs[k])
            ? attrs[k].forEach((o) => (o !== '' ? e.classList.add(o) : 0))
            : attrs[k] !== ''
            ? e.classList.add(attrs[k])
            : 0;
        } else if (k === 'style') {
          Object.keys(attrs[k]).forEach((ks) => {
            e.style[ks] = attrs[k][ks];
          });
        } else if (k === 'text') {
          attrs[k] === '' ? (e.innerHTML = '&nbsp;') : (e.innerText = attrs[k]);
        } else e[k] = attrs[k];
      });
    return e;
  }

  document.querySelectorAll('select[multiple]').forEach((el, k) => {
    var div = newEl('div', {
      class: 'multiselect-dropdown',
      style: { padding: config.style?.padding ?? '' },
    });
    el.style.opacity = '0';
    el.style.height = '0';
    el.style.padding = '0';
    el.style.border = 'none';
    el.parentNode.insertBefore(div, el.nextSibling);
    var listWrap = newEl('div', { class: 'multiselect-dropdown-list-wrapper' });
    var list = newEl('div', {
      class: 'multiselect-dropdown-list',
      style: { height: config.height },
    });
    var search = newEl('input', {
      class: ['multiselect-dropdown-search'].concat([
        config.searchInput?.class ?? 'form-control',
      ]),
      style: {
        width: '100%',
        display:
          el.attributes['multiselect-search']?.value === 'true'
            ? 'block'
            : 'none',
      },
      placeholder: config.txtSearch,
    });
    listWrap.appendChild(search);
    div.appendChild(listWrap);
    listWrap.appendChild(list);

    el.loadOptions = () => {
      list.innerHTML = '';

      if (el.attributes['multiselect-select-all']?.value == 'true') {
        var op = newEl('div', { class: 'multiselect-dropdown-all-selector' });
        var ic = newEl('input', { type: 'checkbox' });
        op.appendChild(ic);
        op.appendChild(newEl('label', { text: config.txtAll }));

        op.addEventListener('click', () => {
          op.classList.toggle('checked');
          op.querySelector('input').checked =
            !op.querySelector('input').checked;

          var ch = op.querySelector('input').checked;
          list
            .querySelectorAll(
              ':scope > div:not(.multiselect-dropdown-all-selector)'
            )
            .forEach((i) => {
              if (i.style.display !== 'none') {
                i.querySelector('input').checked = ch;
                i.optEl.selected = ch;
              }
            });

          el.dispatchEvent(new Event('change'));
        });
        ic.addEventListener('click', (ev) => {
          ic.checked = !ic.checked;
        });
        el.addEventListener('change', (ev) => {
          let itms = Array.from(
            list.querySelectorAll(
              ':scope > div:not(.multiselect-dropdown-all-selector)'
            )
          ).filter((e) => e.style.display !== 'none');
          let existsNotSelected = itms.find(
            (i) => !i.querySelector('input').checked
          );
          if (ic.checked && existsNotSelected) ic.checked = false;
          else if (ic.checked == false && existsNotSelected === undefined)
            ic.checked = true;
        });

        list.appendChild(op);
      }

      Array.from(el.options).map((o) => {
        var op = newEl('div', { class: o.selected ? 'checked' : '', optEl: o });
        var ic = newEl('input', { type: 'checkbox', checked: o.selected });
        op.appendChild(ic);
        var label = newEl('label');
        if (o.hasAttribute('flag')) {
          let flag = o.getAttribute('flag');
          label.appendChild(
            newEl('img', { src: 'https://content.coinis.com/' + flag })
          );
        }
        label.appendChild(newEl('span', { text: o.text }));
        op.appendChild(label);

        op.addEventListener('click', () => {
          op.classList.toggle('checked');
          op.querySelector('input').checked =
            !op.querySelector('input').checked;
          op.optEl.selected = !!!op.optEl.selected;
          el.dispatchEvent(new Event('change'));
        });
        ic.addEventListener('click', (ev) => {
          ic.checked = !ic.checked;
        });
        o.listitemEl = op;
        list.appendChild(op);
      });
      div.listEl = listWrap;

      div.refresh = () => {
        div
          .querySelectorAll('span.optext, span.placeholder')
          .forEach((t) => div.removeChild(t));
        var sels = Array.from(el.selectedOptions);
        if (
          sels.length > (el.attributes['multiselect-max-items']?.value ?? 3)
        ) {
          div.appendChild(
            newEl('span', {
              class: ['optext', 'maxselected'],
              text: sels.length + ' ' + config.txtSelected,
            })
          );
        } else {
          sels.map((x) => {
            var c = newEl('span', { class: 'optext', srcOption: x });
            if (x.hasAttribute('flag')) {
              let flag = x.getAttribute('flag');
              c.appendChild(
                newEl('img', { src: 'https://content.coinis.com/' + flag })
              );
            }
            c.appendChild(newEl('span', { text: x.text }));
            if (el.attributes['multiselect-hide-x']?.value !== 'true')
              c.appendChild(
                newEl('span', {
                  class: 'optdel',
                  text: 'x',
                  title: config.txtRemove,
                  onclick: (ev) => {
                    c.srcOption.listitemEl.dispatchEvent(new Event('click'));
                    div.refresh();
                    ev.stopPropagation();
                  },
                })
              );

            div.appendChild(c);
          });
        }
        if (0 == el.selectedOptions.length)
          div.appendChild(
            newEl('span', {
              class: 'placeholder',
              text: el.attributes['placeholder']?.value ?? config.placeholder,
            })
          );
      };
      div.refresh();
    };
    el.loadOptions();

    search.addEventListener('input', () => {
      list
        .querySelectorAll(':scope div:not(.multiselect-dropdown-all-selector)')
        .forEach((d) => {
          var txt = d.querySelector('label').innerText.toUpperCase();
          d.style.display = txt.includes(search.value.toUpperCase())
            ? 'block'
            : 'none';
        });
    });

    div.addEventListener('click', () => {
      div.listEl.style.display = 'block';
      search.focus();
      search.select();
    });

    document.addEventListener('click', function (event) {
      if (!div.contains(event.target)) {
        listWrap.style.display = 'none';
        div.refresh();
      }
    });
  });
}
// -------------------- MULTISELECT JS END --------------------

$(document).ready(function () {
  MultiselectDropdown(window.MultiselectDropdownOptions);
});

$(document).ready(function () {
  const $sendButton = $('#send');
  const $nameField = $('#name');
  const $surnameField = $('#surname');
  const $emailField = $('#email');
  const $contactField = $('#contact');
  const $companyField = $('#company-name');
  const $userTypeField = $('#user-type');
  const $assignedToField = $('#assigned-to');
  const $descriptionField = $('#description');
  const $notesField = $('#notes');

  const $verticalField = $('#vertical');

  const $offerFlowField = $('#flow-of-offer');
  const $trafficTypeField = $('#other-traffic-type');
  const $monthlyBudgetField = $('#monthly-budget');

  const $topOfferField = $('#top-offer');
  const $networkExperienceField = $('#other-networks-experience');
  const $preferableOfferFlowField = $('#preferable-flow-of-offer');
  const $trafficTypePubField = $('#traffic-type');
  const $monthlyEarningsField = $('#monthly-earnings');

  $sendButton.click(async (event) => {
    event.preventDefault();
    const name = $nameField.val();
    const surname = $surnameField.val();
    const email = $emailField.val();
    const contact = $contactField.val();
    const companyName = $companyField.val();
    const userType = $userTypeField.val();
    const assignedTo = $assignedToField.val();
    const description = $descriptionField.val();
    const notes = $notesField.val();

    const vertical_input = $verticalField.val();

    const offerFlow = $offerFlowField.val();
    const trafficType = $trafficTypeField.val();
    const monthlyBudget = $monthlyBudgetField.val();

    const topOffer = $topOfferField.val();
    const networkExperience = $networkExperienceField.val();
    const preferableOfferFlow = $preferableOfferFlowField.val();
    const trafficTypePub = $trafficTypePubField.val();
    const monthlyEarnings = $monthlyEarningsField.val();

    const baseData = {
      name: `${name} ${surname}`.trim(),
      email,
      contact_info: contact,
      company_name: companyName,
      user_type: userType,
      assignee: assignedTo,
      description,
      notes,
      verticals: vertical_input,
    };
    const dataObj = {
      ...baseData,
      ...($('#user-type').val() === 'Advertiser'
        ? {
            flow_of_offer: offerFlow,
            other_traffic_type: trafficType,
            monthly_earnings: monthlyBudget,
          }
        : {
            top_offers: topOffer,
            other_networks_experience: networkExperience,
            flow_of_offer: preferableOfferFlow,
            other_traffic_type: trafficTypePub,
            monthly_earnings: monthlyEarnings,
          }),
    };

    if ($('#user-type').val() === 'Advertiser') {
      if (
        !name ||
        !surname ||
        !email ||
        !contact ||
        !assignedTo ||
        !userType ||
        !description ||
        !notes ||
        vertical_input.length === 0 ||
        !offerFlow ||
        !trafficType ||
        !monthlyBudget
      ) {
        showToast('You must fill all fields', TOAST_ERROR_TYPE);
        return;
      }
    } else {
      if (
        !name ||
        !surname ||
        !email ||
        !contact ||
        !assignedTo ||
        !userType ||
        !description ||
        !notes ||
        vertical_input.length === 0 ||
        !networkExperience ||
        !preferableOfferFlow ||
        !trafficTypePub ||
        !monthlyEarnings
      ) {
        showToast('You must fill all fields', TOAST_ERROR_TYPE);
        return;
      }
    }

    $sendButton.attr('disabled', true);
    $sendButton.text('Sending...');

    await fetch('/api/leads/', {
      method: 'POST',
      body: JSON.stringify(dataObj),
    })
      .then((response) => {
        location.href = '/thank-you?form=lead-gen';
      })
      .catch((error) => {
        $sendButton.attr('disabled', false);
        $sendButton.text('Send');
      });
  });
});

// ADVERTISER-PUBLISHER SERCION
$('#publisher-form-inputs').hide();
$('#advertiser-form-inputs').hide();

$('#user-type').change(function () {
  if ($('#user-type').val() === 'Advertiser') {
    $('#advertiser-form-inputs').show();
    $('#publisher-form-inputs').hide();
  } else if ($('#user-type').val() === 'Publisher') {
    $('#publisher-form-inputs').show();
    $('#advertiser-form-inputs').hide();
  } else {
    $('#publisher-form-inputs').hide();
    $('#advertiser-form-inputs').hide();
  }
});
